import { AuthType } from '../types';

type MethodType = 'GET' | 'POST' | 'PUT' | 'DELETE' | 'PATCH'

type HeadersType = {
  h?: AuthType | unknown,
  isMultiply?: boolean
}

function headers({ h, isMultiply }: HeadersType) {
  const headers = new Headers();
  const tokenString = localStorage.getItem('token');
  let token = '';
  if (tokenString !== null) {
    token = JSON.parse(tokenString);
  }
  if(!isMultiply){
    headers.append('Content-Type', 'application/json');
  }
  if (tokenString === null && !isMultiply && h) {
    const authHeaders = h as AuthType;
    headers.append('Authorization', 'Basic ' + new Buffer(authHeaders.login + ':' + authHeaders.password).toString('base64'));
  } else if (tokenString !== null) {
    headers.append('Authorization', 'Bearer ' + token);
  }
  return headers;
}

function request<D>(method: MethodType, path: string, data?: D | AuthType, isMultiply?: boolean, withResponse?: boolean) {
  const url = `${path}`;
  const options: { method: MethodType, headers: Headers, body?: string | FormData } = {
    method, headers: method === 'GET' ?
      headers({ h: data, isMultiply: isMultiply }) : headers({ isMultiply: isMultiply })
  };
  if (data && method !== 'GET' &&  !isMultiply) {
    options.body = JSON.stringify(data);
  }
  else if (isMultiply){
    options.body = data as unknown as FormData;
  }
  return fetch(url, options)
    .then((response) => {
      if (response.ok) {
        const contentType = response.headers.get('content-type');
        if(withResponse){
          return response;
        }
        return (contentType && contentType.indexOf('application/json') !== -1) ? response.json() : response;
      }
      else{
        throw new Error(response.statusText, { cause: response.status });
      }
    }).catch(e => {
      throw new Error (e.name, { cause: e?.cause });
    });
}

interface ApiI<D, R> {
  get: (path: string, cred?: AuthType | undefined, isMultiply?: boolean, withResponse?: boolean) => Promise<R>,
  post: (path: string, data: D, isMultiply?: boolean , withResponse?: boolean) => Promise<R>,
  put: (path: string, data?: D, isMultiply?: boolean , withResponse?: boolean) => Promise<R>,
  delete: (path: string, data?: D, isMultiply?: boolean , withResponse?: boolean) => Promise<R>
  patch: (path:string, data?: D, isMultiply? : boolean , withResponse?: boolean) => Promise<R>
}

function Api<T, R>(): ApiI<T, R> {
  return {
    get(path, cred, isMultiply, withResponse) {
      return request('GET', path, cred, isMultiply, withResponse);
    },

    post(path, data,isMultiply, withResponse) {
      return request('POST', path, data, isMultiply, withResponse);
    },

    put(path, data,isMultiply, withResponse) {
      return request('PUT', path, data, isMultiply, withResponse);
    },

    delete(path, data,isMultiply, withResponse) {
      return request('DELETE', path, data, isMultiply, withResponse);
    },
    patch(path,data,isMultiply, withResponse){
      return request('PATCH', path,data,isMultiply, withResponse);
    }
  };
}

export default Api;


